/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const membershipUpdateRestRequestSchema = z.object({
  commitment: z.number().nullish(),
  endDate: z.iso.date().nullish(),
  roleId: z.int().nullish(),
  startDate: z.iso.date().nullish(),
});
